import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StationService } from 'src/app/services/station.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { BsModalService } from "ngx-bootstrap";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-promo-services',
  templateUrl: './promo-services.component.html',
  styleUrls: ['./promo-services.component.scss']
})
export class PromoServicesComponent implements OnInit{
  allPromoServices;
  stationsListForPromo;
  activePageForPromo;
  urlValue:any;
  showUrlBox = false;
  promoCodeValue:any
  searchTextForPromo;
  filters_form: FormGroup;
  isShow: boolean = false;
  contractIds = []
  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private reservationService: ReservationService,
    private stationService: StationService,
    private modalService: BsModalService,
    private notifier: NotifierService,
  private formBuilder :FormBuilder) {
    this.getDataForPromo();
    this.notifier = notifier;
  }

  ngOnInit() { 
    this.filters_form = this.formBuilder.group({
      contractID: new FormControl(""),
    });
    this.getDataForPromo();
    this.uniqueContractIds()
  }
  getDataForPromo() {
    this.searchTextForPromo = ''
    this.isShow = false;
    this.filters_form = this.formBuilder.group({
      contractID: new FormControl(""),
    });
    this.getPromoServices();
    this.showUrlBox = false;
  }
  addPromoService() {
    this.router.navigateByUrl("home/add-promo-service");
    this.getDataForPromo()
  }
  // editPromoService(contractService) {
  //   // this.router.navigate(["home/edit-contract-service",contractService.CONTRACTBYSTATIONID,contractService.CONTRACTSERVICESID])
  // }
  
  getPromoServices() {
    this.spinner.show();
    this.reservationService.getPromoServices().subscribe(res => {
      this.allPromoServices = res['result'].sort((a,b) => a.STATIONID.localeCompare(b.STATIONID));
      this.spinner.hide();
    });
  }

  getPromoServicesByStationIds() {
    // this.employeeService.getEmployeesByStationId(this.stationsList).subscribe(data => {
    //   this.spinner.hide();
    //   if (data['result'] != null) {
    //     this.allEmployees = data['result'] as [];
    //     this.allEmployees = this.allEmployees.reverse();
    //   }
    // });
  }
  getAllStations() {
    this.stationService.getStations().subscribe(stations => {
      this.stationsListForPromo = stations['result'];
    })
  }

  showFilter() {
    this.isShow = !this.isShow;
    this.uniqueContractIds()
  }
 uniqueContractIds(){
  this.reservationService.getcontractIds().subscribe(contractIds => {
    this.contractIds = contractIds['result'];
  })
 }
 onSearch(formValues){
  if (formValues.contractID.length == 0) {
    this.notifier.notify("warning", "Please search with option");
    return;
  }
  else{
    let code = formValues.contractID
    let url = environment.url
    this.showUrlBox = false;
    if(code){
      this.showUrlBox = true;
      this.promoCodeValue = code;
      this.urlValue = url+'/retail/'+code;
    }
    else{
      this.showUrlBox = false;
      this.promoCodeValue = '';
      this.urlValue = ''
    }
    this.spinner.show();
    this.allPromoServices = [];
    this.reservationService.getPromoServicesBySearch(formValues).subscribe(
      (res: any) => {
        if (res.result.length == 0) {
          this.notifier.notify("warning", "No data found!");
        }
        this.allPromoServices = res['result'];
        this.spinner.hide();
      },
      err => {
        console.log(err);
      }
    );
  }
 }
 copyToClipboard(url: string): void {
  navigator.clipboard.writeText(url).then(() => {
    this.notifier.notify('success', 'url copied.');
      // alert('URL copied to clipboard!');
  }).catch(err => {
      console.error('Failed to copy: ', err);
  });
}
}
